module.exports = __webpack_public_path__ + "static/media/startup.6707791c.png";